import { render, staticRenderFns } from "./PpomStatsHome.vue?vue&type=template&id=4cd0f146&scoped=true"
import script from "./PpomStatsHome.vue?vue&type=script&lang=js"
export * from "./PpomStatsHome.vue?vue&type=script&lang=js"
import style0 from "./PpomStatsHome.vue?vue&type=style&index=0&id=4cd0f146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd0f146",
  null
  
)

export default component.exports